export default function lineKeyTemplateReducer(lineKeyTemplate, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "preferredDevice": {
      const device = action.list.find((_device) => _device.id === action.value);

      return { ...lineKeyTemplate, preferredDevice: device, preferredDeviceId: device.id };
    }

    case "addLineKey":
      return { ...lineKeyTemplate, lineKeys: [...lineKeyTemplate.lineKeys, action.value] };
    case "deleteLineKey":
      return {
        ...lineKeyTemplate,
        lineKeys: lineKeyTemplate.lineKeys.filter((_lineKey) => _lineKey.id !== action.value.id),
      };
    case "updateLineKey":
      return {
        ...lineKeyTemplate,
        lineKeys: lineKeyTemplate.lineKeys.map((_lineKey) => {
          if (_lineKey.id === action.value.id) {
            return action.value;
          }

          return _lineKey;
        }),
      };

    default:
      return { ...lineKeyTemplate, [action.type]: action.value };
  }
}
